<ng-content></ng-content>
<div *ngIf="_busy" class="wl-busy-overlay" [ngClass]="{ 'wl-busy-overlay-center': busyCenter }">
  <wl-busy [show]="true"></wl-busy> {{ busyMessage }}
</div>
